import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AllocationViewProfileItemFacade } from '../item/allocation-view-profile-item.facade';
import { checkStoreState, setInitialStoreState } from '../../../../../common';

@Injectable({
  providedIn: 'root',
})
export class AllocationViewProfileItemGuard {
  constructor(private allocationViewProfileItemFacade: AllocationViewProfileItemFacade) {}

  canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    const {
      params: { profileId },
    } = route;

    return checkStoreState(this.allocationViewProfileItemFacade, profileId);
  }

  canDeactivate(): boolean {
    return setInitialStoreState(this.allocationViewProfileItemFacade);
  }
}
